export const colorsConstants = {
  activeColor: "primary",
  bgColor: "white",
};
